/* ============================================================
   MARECHAL — theme.js (sem dependências)
   ============================================================ */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, settings: {}, strings: {}, moneyFormat: 'R$ {{amount_with_comma_separator}}' };

  /* ---------- Utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '', pattern = /\{\{\s*(\w+)\s*\}\}/, f = format || T.moneyFormat;
    function delim(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    switch (f.match(pattern)[1]) {
      case 'amount': value = delim(cents, 2); break;
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      default: value = delim(cents, 2);
    }
    return f.replace(pattern, value);
  }

  var overlay = $('[data-overlay]');
  var openLayers = [];
  function showOverlay() { if (!overlay) return; overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); document.body.style.overflow = 'hidden'; }
  function hideOverlay() { if (!overlay) return; overlay.classList.remove('is-visible'); setTimeout(function () { if (!openLayers.length) overlay.hidden = true; }, 200); document.body.style.overflow = ''; }
  function openLayer(el, cls) {
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add(cls || 'is-open'); });
    openLayers.push({ el: el, cls: cls || 'is-open' });
    showOverlay();
    var focusable = el.querySelector('input, button, a, select, textarea, [tabindex]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }
  function closeLayer(el) {
    openLayers = openLayers.filter(function (l) {
      if (l.el !== el) return true;
      l.el.classList.remove(l.cls);
      setTimeout(function () { l.el.hidden = true; }, 280);
      return false;
    });
    if (!openLayers.length) hideOverlay();
  }
  function closeTopLayer() { if (openLayers.length) closeLayer(openLayers[openLayers.length - 1].el); }
  if (overlay) overlay.addEventListener('click', closeTopLayer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTopLayer(); });

  /* ---------- Header sticky ---------- */
  (function () {
    var header = $('[data-header]');
    if (!header || !header.hasAttribute('data-sticky')) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 220 && y < last) header.classList.add('is-stuck');
      else if (y <= 60 || y > last) header.classList.remove('is-stuck');
      last = y;
    }, { passive: true });
  })();

  /* ---------- Menu mobile ---------- */
  (function () {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    $$('[data-mobile-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openLayer(menu); btn.setAttribute('aria-expanded', 'true'); });
    });
    $$('[data-mobile-menu-close]', menu).forEach(function (btn) {
      btn.addEventListener('click', function () { closeLayer(menu); });
    });
  })();

  /* ---------- Categories Drawer ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cat-open]')) {
      var d = document.getElementById('CatDrawer');
      if (!d) return;
      d.hidden = false;
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('[data-cat-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    if (e.target.closest('[data-cat-close]') ||
        (e.target.closest('[data-overlay]') &&
         document.getElementById('CatDrawer') &&
         document.getElementById('CatDrawer').classList.contains('is-open'))) {
      var d = document.getElementById('CatDrawer');
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { d.hidden = true; }, 300);
      document.querySelectorAll('[data-cat-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });

/* ---------- Voltar ao topo ---------- */
  (function () {
    var btn = $('[data-back-to-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 700);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  })();

  /* ---------- Hero slider ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('[data-hero-slide]', hero);
    if (slides.length < 2) return;
    var dots = $$('[data-hero-dot]', hero);
    var idx = 0, timer = null, delay = (parseInt(hero.dataset.autoplay, 10) || 0) * 1000;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }
    function play() { if (delay > 0) timer = setInterval(function () { go(idx + 1); }, delay); }
    function stop() { clearInterval(timer); }
    var prev = $('[data-hero-prev]', hero), next = $('[data-hero-next]', hero);
    if (prev) prev.addEventListener('click', function () { stop(); go(idx - 1); play(); });
    if (next) next.addEventListener('click', function () { stop(); go(idx + 1); play(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { stop(); go(i); play(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', function () { stop(); play(); });
    var sx = 0;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 46) go(idx + (dx < 0 ? 1 : -1));
      play();
    }, { passive: true });
    play();
  });

  /* ---------- Sliders de produto ---------- */
  $$('[data-product-slider]').forEach(function (slider) {
    var track = $('[data-slider-track]', slider);
    if (!track) return;
    function step() { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 16 : 300; }
    var prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (cd) {
    var raw = (cd.dataset.end || '').trim().replace(' ', 'T');
    if (!raw) return;
    var end = new Date(raw).getTime();
    if (isNaN(end)) return;
    var els = { d: $('[data-cd="d"]', cd), h: $('[data-cd="h"]', cd), m: $('[data-cd="m"]', cd), s: $('[data-cd="s"]', cd) };
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { cd.classList.add('is-finished'); clearInterval(t); return; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
      if (els.d) els.d.textContent = pad(d);
      if (els.h) els.h.textContent = pad(h);
      if (els.m) els.m.textContent = pad(m);
      if (els.s) els.s.textContent = pad(s);
    }
    tick();
    var t = setInterval(tick, 1000);
  });

  /* ---------- Carrinho (AJAX + drawer) ---------- */
  var Cart = {
    drawer: $('[data-cart-drawer]'),
    open: function () { if (this.drawer) openLayer(this.drawer); },
    close: function () { if (this.drawer) closeLayer(this.drawer); },
    bindDrawer: function () {
      var self = this;
      if (!this.drawer) return;
      $$('[data-cart-close]', this.drawer).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      $$('[data-line-remove]', this.drawer).forEach(function (b) {
        b.addEventListener('click', function () { self.change(b.dataset.lineRemove, 0); });
      });
      $$('[data-qty-minus][data-line-change]', this.drawer).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = $('[data-line-qty="' + b.dataset.lineChange + '"]', self.drawer);
          self.change(b.dataset.lineChange, Math.max(0, parseInt(input.value, 10) - 1));
        });
      });
      $$('[data-qty-plus][data-line-change]', this.drawer).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = $('[data-line-qty="' + b.dataset.lineChange + '"]', self.drawer);
          self.change(b.dataset.lineChange, parseInt(input.value, 10) + 1);
        });
      });
      $$('[data-line-qty]', this.drawer).forEach(function (input) {
        input.addEventListener('change', function () { self.change(input.dataset.lineQty, Math.max(0, parseInt(input.value, 10) || 0)); });
      });
      var note = $('[data-cart-note]', this.drawer);
      if (note) note.addEventListener('change', function () {
        fetch(T.routes.cartUpdate + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });
    },
    refresh: function (openAfter) {
      var self = this;
      if (!this.drawer) return this.updateCount();
      this.drawer.classList.add('is-loading');
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-drawer]');
          if (fresh) {
            var wasOpen = self.drawer.classList.contains('is-open');
            fresh.hidden = self.drawer.hidden;
            if (wasOpen) fresh.classList.add('is-open');
            self.drawer.replaceWith(fresh);
            self.drawer = fresh;
            openLayers = openLayers.map(function (l) { return l.el.hasAttribute && l.el.hasAttribute('data-cart-drawer') ? { el: fresh, cls: l.cls } : l; });
            self.bindDrawer();
          }
          self.updateCount();
          if (openAfter) self.open();
        })
        .catch(function () { self.drawer.classList.remove('is-loading'); });
    },
    updateCount: function () {
      fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
    },
    add: function (formData, btn) {
      var self = this;
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      return fetch(T.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          if (!res.ok) { alert(res.json.description || T.strings.cartError || 'Erro ao adicionar.'); return; }
          if (T.settings.cartType === 'drawer' && self.drawer) self.refresh(true);
          else window.location.href = T.routes.cart;
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
    },
    change: function (line, qty) {
      var self = this;
      this.drawer.classList.add('is-loading');
      fetch(T.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function () { self.refresh(false); });
    }
  };
  Cart.bindDrawer();
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart-form], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    Cart.add(new FormData(form), form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && T.settings.cartType === 'drawer' && Cart.drawer) { e.preventDefault(); Cart.open(); }
  });

  /* ---------- Quantidade (genérico, fora do drawer) ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]:not([data-line-change])');
    var plus = e.target.closest('[data-qty-plus]:not([data-line-change])');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    input.value = minus ? Math.max(min, val - 1) : val + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Busca preditiva ---------- */
  (function () {
    var wrap = $('[data-predictive-wrap]');
    if (!wrap) return;
    var input = $('[data-predictive-input]', wrap);
    var panel = $('[data-predictive-results]', wrap);
    if (!input || !panel) return;
    function hide() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function mark(text, q) {
      var safe = escapeHtml(text);
      try {
        var rx = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        return safe.replace(rx, '<mark>$1</mark>');
      } catch (e) { return safe; }
    }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      var url = T.routes.predictive + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = data.resources.results;
          var html = '';
          if (res.products && res.products.length) {
            html += '<p class="predictive__group-title">Produtos</p>';
            res.products.forEach(function (p) {
              html += '<a class="predictive__item" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                '<span><span class="predictive__item-title">' + mark(p.title, q) + '</span>' +
                '<span class="predictive__item-price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
            });
          }
          if (res.collections && res.collections.length) {
            html += '<p class="predictive__group-title">Categorias</p>';
            res.collections.forEach(function (c) {
              html += '<a class="predictive__item" href="' + c.url + '"><span class="predictive__item-title">' + mark(c.title, q) + '</span></a>';
            });
          }
          if (res.articles && res.articles.length) {
            html += '<p class="predictive__group-title">Guias</p>';
            res.articles.forEach(function (a) {
              html += '<a class="predictive__item" href="' + a.url + '"><span class="predictive__item-title">' + mark(a.title, q) + '</span></a>';
            });
          }
          if (!html) html = '<p class="predictive__empty">Nada encontrado para "' + escapeHtml(q) + '". Tente o código OEM ou o nome da peça.</p>';
          html += '<a class="predictive__all" href="' + T.routes.search + '?q=' + encodeURIComponent(q) + '&type=product,article,page">Ver todos os resultados →</a>';
          panel.innerHTML = html;
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }).catch(hide);
    }, 260);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (panel.innerHTML && input.value.trim().length >= 2) { panel.hidden = false; } });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) hide(); });
  })();

  /* ---------- Wishlist (localStorage) ---------- */
  var Wishlist = {
    key: 'marechal:wishlist',
    get: function () { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    set: function (list) { localStorage.setItem(this.key, JSON.stringify(list.slice(0, 60))); this.paint(); },
    toggle: function (handle) {
      var list = this.get(), i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1); else list.unshift(handle);
      this.set(list);
      return i === -1;
    },
    paint: function () {
      var list = this.get();
      $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.hidden = !list.length; });
      $$('[data-wishlist]').forEach(function (btn) {
        var active = list.indexOf(btn.dataset.wishlist) > -1;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  };
  Wishlist.paint();
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (btn) { e.preventDefault(); Wishlist.toggle(btn.dataset.wishlist); }
  });

  /* ---------- Quick view + lista de favoritos ---------- */
  var QuickView = {
    modal: $('[data-quick-view-modal]'),
    content: null,
    init: function () {
      if (!this.modal) return;
      this.content = $('[data-quick-view-content]', this.modal);
      var self = this;
      $$('[data-modal-close]', this.modal).forEach(function (b) { b.addEventListener('click', function () { closeLayer(self.modal); }); });
    },
    open: function (html) {
      if (!this.modal) return;
      this.content.innerHTML = html;
      openLayer(this.modal, 'is-open');
    },
    variantOptionsHtml: function (p) {
      if (p.variants.length <= 1) return '<input type="hidden" name="id" value="' + p.variants[0].id + '">';
      var html = '<label class="product-form__option"><span>Versão</span><select name="id">';
      p.variants.forEach(function (v) {
        html += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
          escapeHtml(v.title) + ' — ' + formatMoney(v.price) + (v.available ? '' : ' (esgotado)') + '</option>';
      });
      return html + '</select></label>';
    },
    product: function (handle) {
      var self = this;
      this.open('<div class="skeleton quick-view__skeleton"></div>');
      fetch(T.routes.root + 'products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image + '&width=600" alt="' + escapeHtml(p.title) + '" onerror="this.src=\'' + p.featured_image + '\'">' : '';
          var priceHtml = '<div class="price' + (p.compare_at_price > p.price ? ' price--sale' : '') + '">' +
            (p.compare_at_price > p.price ? '<s class="price__compare">' + formatMoney(p.compare_at_price) + '</s>' : '') +
            '<span class="price__current">' + formatMoney(p.price) + '</span></div>';
          var html = '<div class="quick-view__grid">' +
            '<div class="quick-view__img">' + img + '</div>' +
            '<div><h2 class="h3">' + escapeHtml(p.title) + '</h2>' + priceHtml +
            '<form class="product-form" data-ajax-cart-form style="margin-top:16px">' +
            self.variantOptionsHtml(p) +
            '<div class="product-form__row" style="margin-top:12px">' +
            '<div class="qty" data-qty><button type="button" data-qty-minus aria-label="-">−</button>' +
            '<input type="number" name="quantity" value="1" min="1"><button type="button" data-qty-plus aria-label="+">+</button></div>' +
            '<button type="submit" class="btn btn--primary product-form__atc"' + (p.available ? '' : ' disabled') + '>' +
            (p.available ? (T.strings.addToCart || 'Adicionar ao carrinho') : (T.strings.soldOut || 'Esgotado')) + '</button></div></form>' +
            '<a class="quick-view__link" href="' + p.url + '">Ver página completa da peça →</a></div></div>';
          self.open(html);
        })
        .catch(function () { self.open('<p class="predictive__empty">Não foi possível carregar. Abra a página do produto.</p>'); });
    },
    wishlist: function () {
      var self = this, list = Wishlist.get();
      if (!list.length) { this.open('<h2 class="h4">Favoritos</h2><p class="predictive__empty">Você ainda não favoritou nenhuma peça. Toque no coração dos produtos para salvar aqui.</p>'); return; }
      this.open('<h2 class="h4">Favoritos</h2><div class="skeleton quick-view__skeleton" style="margin-top:14px"></div>');
      Promise.all(list.slice(0, 12).map(function (h) {
        return fetch(T.routes.root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var html = '<h2 class="h4">Favoritos</h2><div class="cart-xsell__list" style="margin-top:16px">';
        products.filter(Boolean).forEach(function (p) {
          html += '<div class="cart-xsell__item">' +
            (p.featured_image ? '<a class="cart-xsell__media" href="' + p.url + '"><img src="' + p.featured_image + '" alt="" loading="lazy"></a>' : '') +
            '<div class="cart-xsell__info"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a><span>' + formatMoney(p.price) + '</span></div>' +
            '<button type="button" class="icon-btn" data-wishlist="' + p.handle + '" aria-pressed="true" aria-label="Remover dos favoritos">✕</button></div>';
        });
        self.open(html + '</div>');
      });
    }
  };
  QuickView.init();
  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); QuickView.product(qv.dataset.quickView); }
    var wl = e.target.closest('[data-wishlist-open]');
    if (wl) { e.preventDefault(); QuickView.wishlist(); }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist]') && QuickView.modal && QuickView.modal.classList.contains('is-open')) {
      var item = e.target.closest('.cart-xsell__item');
      if (item) item.remove();
    }
  });

  /* ---------- Facets / filtros ---------- */
  (function () {
    var form = $('[data-facets-form]');
    if (!form) return;
    var drawer = $('[data-facets-drawer]');
    var sortInput = $('[data-facets-sort-input]', form);
    var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
    var autoSubmit = debounce(function () { if (isDesktop()) form.submit(); }, 500);
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) autoSubmit();
    });
    $$('[data-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (sortInput) sortInput.value = sel.value;
        form.submit();
      });
    });
    $$('[data-facets-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (drawer) openLayer(drawer); });
    });
    $$('[data-facets-close]').forEach(function (b) {
      b.addEventListener('click', function () { if (drawer) closeLayer(drawer); });
    });
  })();

  /* ---------- Busca por veículo ---------- */
  (function () {
    var form = $('[data-vehicle-finder]');
    if (!form) return;
    var data = {};
    (form.dataset.brands || '').split('\n').forEach(function (line) {
      var parts = line.split('|');
      if (parts.length < 1 || !parts[0].trim()) return;
      data[parts[0].trim()] = (parts[1] || '').split(',').map(function (m) { return m.trim(); }).filter(Boolean);
    });
    var marca = $('[data-vf="marca"]', form), modelo = $('[data-vf="modelo"]', form);
    Object.keys(data).forEach(function (b) {
      var o = document.createElement('option'); o.value = b; o.textContent = b; marca.appendChild(o);
    });
    marca.addEventListener('change', function () {
      modelo.innerHTML = '';
      var models = data[marca.value] || [];
      modelo.disabled = !models.length;
      var first = document.createElement('option');
      first.value = ''; first.textContent = models.length ? 'Todos os modelos' : 'Selecione a marca primeiro';
      modelo.appendChild(first);
      models.forEach(function (m) {
        var o = document.createElement('option'); o.value = m; o.textContent = m; modelo.appendChild(o);
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var parts = [];
      ['marca', 'modelo', 'versao', 'ano', 'categoria'].forEach(function (k) {
        var el = $('[data-vf="' + k + '"]', form);
        if (el && el.value.trim()) parts.push(el.value.trim());
      });
      var q = parts.join(' ');
      window.location.href = T.routes.search + '?q=' + encodeURIComponent(q) + '&type=product';
    });
  })();

  /* ---------- Texto SEO expansível ---------- */
  $$('[data-seo-toggle]').forEach(function (btn) {
    var content = btn.previousElementSibling;
    btn.addEventListener('click', function () {
      var collapsed = content.dataset.collapsed === 'true';
      content.dataset.collapsed = collapsed ? 'false' : 'true';
      btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      btn.firstChild.textContent = (collapsed ? btn.dataset.less : btn.dataset.more) + ' ';
    });
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (tabs) {
    var btns = $$('[data-tab]', tabs), panels = $$('[data-tab-panel]', tabs);
    function activate(name) {
      btns.forEach(function (b) {
        var on = b.dataset.tab === name;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.dataset.tabPanel === name;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { activate(b.dataset.tab); }); });
    $$('[data-tab-jump]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        activate(link.dataset.tabJump);
        tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });

  /* ---------- Vídeo showcase ---------- */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-video-play]');
    if (!play) return;
    var url = play.dataset.videoUrl;
    if (!/^https:\/\/(www\.)?(youtube\.com|youtu\.be|player\.vimeo\.com|vimeo\.com)\//.test(url)) return;
    var iframe = document.createElement('iframe');
    iframe.className = 'showcase__iframe';
    iframe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'Vídeo');
    play.replaceWith(iframe);
  });

  /* ============================================================
     PÁGINA DO PRODUTO
     ============================================================ */
  (function () {
    var root = $('[data-product]');
    if (!root) return;
    var jsonEl = $('[data-product-json]');
    var product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { }

    /* Galeria */
    var slides = $$('[data-media-index]', root).filter(function (el) { return el.matches('.product-gallery__slide'); });
    var thumbs = $$('[data-thumb]', root);
    function showMedia(index) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaIndex == index); });
      thumbs.forEach(function (t) {
        var on = t.dataset.mediaIndex == index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaIndex); }); });

    /* Zoom modal */
    var zoomImgs = slides.map(function (s) { var i = s.querySelector('img'); return i ? i.src.replace(/width=\d+/, 'width=1600') : null; });
    var zoomIdx = 0, zoomModal = null;
    function buildZoom() {
      zoomModal = document.createElement('div');
      zoomModal.className = 'modal zoom-modal';
      zoomModal.hidden = true;
      zoomModal.setAttribute('role', 'dialog');
      zoomModal.setAttribute('aria-modal', 'true');
      zoomModal.innerHTML = '<div class="modal__backdrop" data-zoom-close></div>' +
        '<div class="modal__panel"><button type="button" class="modal__close icon-btn" data-zoom-close aria-label="Fechar">✕</button>' +
        '<img class="zoom-modal__img" alt="" data-zoom-img>' +
        (zoomImgs.length > 1 ? '<button type="button" class="icon-btn zoom-modal__nav zoom-modal__nav--prev" data-zoom-prev aria-label="Anterior">‹</button>' +
          '<button type="button" class="icon-btn zoom-modal__nav zoom-modal__nav--next" data-zoom-next aria-label="Próxima">›</button>' : '') + '</div>';
      document.body.appendChild(zoomModal);
      zoomModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-zoom-close]')) closeLayer(zoomModal);
        if (e.target.closest('[data-zoom-prev]')) showZoom(zoomIdx - 1);
        if (e.target.closest('[data-zoom-next]')) showZoom(zoomIdx + 1);
      });
    }
    function showZoom(i) {
      var valid = zoomImgs.filter(Boolean);
      if (!valid.length) return;
      zoomIdx = (i + zoomImgs.length) % zoomImgs.length;
      if (!zoomImgs[zoomIdx]) return showZoom(zoomIdx + 1);
      $('[data-zoom-img]', zoomModal).src = zoomImgs[zoomIdx];
    }
    root.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom-open]');
      if (!z) return;
      if (!zoomModal) buildZoom();
      showZoom(parseInt(z.dataset.zoomOpen, 10) || 0);
      openLayer(zoomModal, 'is-open');
    });

    /* Variantes */
    var selects = $$('[data-option-select]', root);
    var idInput = $('[data-variant-id]', root);
    var atc = $('[data-atc]', root);
    var atcText = $('[data-atc-text]', root);
    function currentVariant() {
      if (!product || !selects.length) return null;
      var opts = selects.map(function (s) { return s.value; });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateVariant() {
      var v = currentVariant();
      if (!v) {
        if (atc) { atc.disabled = true; if (atcText) atcText.textContent = T.strings.unavailable || 'Indisponível'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      var priceEl = $('[data-price]', root), compareEl = $('[data-compare-price]', root);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      var inst = $('[data-installments]', root);
      if (inst) {
        var n = parseInt(inst.dataset.max, 10) || 1;
        inst.textContent = inst.textContent.replace(/de\s[^\s]+(\s|$)/, 'de ' + formatMoney(Math.floor(v.price / n)) + ' ');
      }
      var skuEl = $('[data-sku]', root);
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? (T.strings.addToCart || 'Adicionar ao carrinho') : (T.strings.soldOut || 'Esgotado');
      }
      var sticky = $('[data-sticky-price]');
      if (sticky) sticky.textContent = formatMoney(v.price);
      if (v.featured_media && slides.length) {
        var target = slides.find(function (s) { return s.dataset.mediaId == v.featured_media.id; });
        if (target) showMedia(target.dataset.mediaIndex);
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

    /* Sticky ATC mobile */
    var stickyBar = $('[data-sticky-atc]');
    var formEl = $('.product-form', root);
    if (stickyBar && formEl) {
      stickyBar.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-enabled', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' });
      io.observe(formEl);
      var buyBtn = $('[data-sticky-buy]', stickyBar);
      if (buyBtn) buyBtn.addEventListener('click', function () { Cart.add(new FormData(formEl), buyBtn); });
    }

    /* Registrar em vistos recentemente */
    try {
      var key = 'marechal:recent';
      var recent = JSON.parse(localStorage.getItem(key)) || [];
      var handle = root.dataset.handle;
      recent = recent.filter(function (h) { return h !== handle; });
      recent.unshift(handle);
      localStorage.setItem(key, JSON.stringify(recent.slice(0, 16)));
    } catch (e) { }
  })();

  /* ---------- Recomendações (fetch da section) ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length > 0) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.children.length) el.innerHTML = fresh.innerHTML;
      }).catch(function () { });
  });

  /* ---------- Vistos recentemente ---------- */
  $$('[data-recently-viewed]').forEach(function (section) {
    var grid = $('[data-recently-viewed-grid]', section);
    var limit = parseInt(section.dataset.limit, 10) || 4;
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem('marechal:recent')) || []; } catch (e) { }
    var current = $('[data-product]');
    if (current) recent = recent.filter(function (h) { return h !== current.dataset.handle; });
    recent = recent.slice(0, limit);
    if (!recent.length) return;
    Promise.all(recent.map(function (h) {
      return fetch(T.routes.root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;
      grid.innerHTML = products.map(function (p) {
        return '<article class="product-card card-hover">' +
          '<div class="product-card__media"><a href="' + p.url + '" class="product-card__link">' +
          (p.featured_image ? '<img class="product-card__img" src="' + p.featured_image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
          '</a></div><div class="product-card__info">' +
          '<h3 class="product-card__title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
          '<div class="price' + (p.compare_at_price > p.price ? ' price--sale' : '') + '">' +
          (p.compare_at_price > p.price ? '<s class="price__compare">' + formatMoney(p.compare_at_price) + '</s>' : '') +
          '<span class="price__current">' + formatMoney(p.price) + '</span></div></div></article>';
      }).join('');
      section.hidden = false;
    });
  });

})();
